import { UseQueryOptions } from '@ts-rest/react-query/v5';
import { type ClientArgs, type ClientInferResponseBody } from '@ts-rest/core';
import { wasticApiContract, type WebContractReviewQueryParams } from '@packages/contracts';
import { REVIEW_QUERY_KEY } from './reviews.query-keys';

export type ReviewRoute = typeof wasticApiContract.web.reviews;
export type GetReviewByIdRoute = ReviewRoute['get'];
export type ListReviewsRoute = ReviewRoute['list'];

export type GetReviewByIdResponse = ClientInferResponseBody<GetReviewByIdRoute, 200>['data']['review'];
export type GetReviewByIdQueryOptions = UseQueryOptions<
	GetReviewByIdRoute,
	ClientArgs,
	GetReviewByIdResponse
>;

export function createGetReviewByIdQueryOptions(reviewId: string): GetReviewByIdQueryOptions {
	return {
		queryKey:  REVIEW_QUERY_KEY.GET(reviewId),
		queryData: { params: { reviewId } },
		select:    data => data.body.data.review,
		enabled:   !!reviewId,
	};
}

export type ListReviewsResponse = ClientInferResponseBody<ListReviewsRoute, 200>['data'];
export type ListReviewsQueryOptions = UseQueryOptions<
	ListReviewsRoute,
	ClientArgs,
	ListReviewsResponse
>;
export function createListReviewsQueryOptions(queryParams: WebContractReviewQueryParams): ListReviewsQueryOptions {
	return {
		queryKey:  REVIEW_QUERY_KEY.LIST(queryParams),
		queryData: { query: queryParams },
		select:    data => data.body.data,
	};
}